import React, { useEffect, useState } from 'react'
import './AdditionalAttachmentEncounter.scss'
import DragDrop from 'src/components/common/DragDrop/DragDrop'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'
import { COLLECTOR_URL } from '../../../apiHelper/apiRoute/collector'
import { format } from 'date-fns'
import {
  collectorApi,
  filterUnwantedFiles,
  onImageDownload,
  uploadPatientFiles,
} from '../../../utils/sharedAttachmentFunctions'
import { getFileSeriesPatient, getVisitAttachments } from '../../../helper/backendHelper'

function getChargeImages(chargeId, setFiles) {
  getVisitAttachments(chargeId).then((res) => {
    filterUnwantedFiles(res, (files) => setFiles(files))
  })
}

function getPatientImages(patientId, setFiles) {
  getFileSeriesPatient(patientId).then((res) => {
    filterUnwantedFiles(res, (files) =>
      setFiles(files.sort((a, b) => new Date(a.file_date) - new Date(b.file_date))),
    )
  })
}

function generateTitle(showCharge, showPatient) {
  if (showCharge && showPatient) {
    return 'patient/visit'
  }
  if (showCharge) {
    return 'visit'
  }
  if (showPatient) {
    return 'patient'
  }

  return 'visit'
}

export default function AdditionalAttachments({
  chargeId,
  patientId,
  title = 'Add attachments',
  showChargeFiles = true,
  showPatientFiles = false,
}) {
  const selectedProvider = useSelector((state) => state.user?.provider)
  const [files, setFiles] = useState([])
  const [patFiles, setPatFiles] = useState([])

  useEffect(() => {
    if (showChargeFiles && chargeId) {
      getChargeImages(chargeId, setFiles)
    }
  }, [chargeId, showChargeFiles])

  useEffect(() => {
    if (showPatientFiles && patientId) {
      getPatientImages(patientId, setPatFiles)
    }
  }, [patientId, showPatientFiles])

  const removeImage = async (file_id) => {
    let url = COLLECTOR_URL.DELETE_UPLOAD.replace('{file_name}', file_id)
    try {
      let res = await collectorApi.delete(url)
      if (res?.data?.status === 'success') {
        toast.success('File deleted.')

        if (showChargeFiles) {
          setFiles((oldFiles) =>
            oldFiles.filter((file) => {
              if (file?.file_id) {
                return file?.file_id !== file_id
              } else {
                return file?.key !== file_id
              }
            }),
          )
        }

        if (showPatientFiles) {
          setPatFiles((oldFiles) =>
            oldFiles.filter((file) => {
              if (file?.file_id) {
                return file?.file_id !== file_id
              } else {
                return file?.key !== file_id
              }
            }),
          )
        }
      } else {
        toast.error('Failed to delete image')
      }
    } catch (e) {
      console.error('Failed to delete image', e)
    }
  }

  return (
    <div className={'AdditionalAttechament-encounter-card'}>
      <div className="AdditionalAttachment-encounter-CardHeader">
        <div className="title-txt">{title}</div>
      </div>
      <div className="drag-drop-encounter">
        <div className="left_enc">
          <div className="AdditionalAttechament-encounter-upload">
            Upload files related to this {generateTitle(showChargeFiles, showPatientFiles)} here.
          </div>
          <DragDrop
            setFiles={async (newFilesFunc) => {
              const newFiles = newFilesFunc(files)
              const mostRecentFile = newFiles[newFiles.length - 1]

              await uploadPatientFiles(mostRecentFile?.file, {
                selectedProvider,
                patientId: patientId,
                chargeid: chargeId,
              })
              toast.success('Uploaded successfully')
              if (showChargeFiles && chargeId) {
                setFiles([...files, mostRecentFile])
                getChargeImages(chargeId, setFiles)
              }
              if (showPatientFiles && patientId) {
                setFiles([...patFiles, mostRecentFile])
                getPatientImages(patientId, setPatFiles)
              }
            }}
            visibleDocument={true}
          />
        </div>

        <div className="right_enc">
          {showChargeFiles && (
            <>
              <p className="encounter-upload-text">Uploaded Charge files ({files.length})</p>
              <div className={files?.length > 0 ? 'fileColor' : 'noFile'}>
                {files?.map((item, i) => {
                  return (
                    <div key={i} style={{ fontSize: '0.7em', marginBottom: '16px' }}>
                      <div
                        style={{ width: '95%' }}
                        onClick={() =>
                          onImageDownload(item?.file_name, item?.originalFileName, 'fileholder')
                        }
                      >
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <div className="file-title">
                            {item?.originalFileName || item?.file_name}
                          </div>
                          <div
                            className="right"
                            onClick={(e) => {
                              e.stopPropagation()
                              removeImage(item?.file_id || item?.key)
                            }}
                          >
                            <i
                              className="far fa-xmark"
                              style={{ fontSize: '1.1em', cursor: 'pointer' }}
                            ></i>
                          </div>
                        </div>
                        <div style={{ display: 'flex' }}>
                          {item?.file_date ? format(new Date(item?.file_date), 'MM/dd/yyyy') : ''}
                          <div style={{ marginLeft: '1.5em' }}>
                            Created by {item?.created_user_name}
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </>
          )}
          {showPatientFiles && (
            <>
              <p className="encounter-upload-text">Uploaded Patient files ({patFiles.length})</p>
              <div className={files?.length > 0 ? 'fileColor' : 'noFile'}>
                {patFiles?.map((item, i) => {
                  return (
                    <div key={i} style={{ fontSize: '0.7em', marginBottom: '16px' }}>
                      <div
                        style={{ width: '95%' }}
                        onClick={() =>
                          onImageDownload(item?.file_name, item?.originalFileName, 'fileholder')
                        }
                      >
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <div className="file-title">
                            {item?.originalFileName || item?.file_name}
                          </div>
                          <div
                            className="right"
                            onClick={(e) => {
                              e.stopPropagation()
                              removeImage(item?.file_id || item?.key)
                            }}
                          >
                            <i
                              className="far fa-xmark"
                              style={{ fontSize: '1.1em', cursor: 'pointer' }}
                            ></i>
                          </div>
                        </div>
                        <div style={{ display: 'flex' }}>
                          {item?.file_date ? format(new Date(item?.file_date), 'MM/dd/yyyy') : ''}
                          <div style={{ marginLeft: '1.5em' }}>
                            Created by {item?.created_user_name}
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
